import { gql } from "@apollo/client";

export default gql`
  query getManagersOfUsers($userIds: [Int!]!) {
    users(ids: $userIds) {
      edges {
        node {
          id
          managersList {
            id
            name
            avatar
          }
        }
      }
    }
  }
`;
